import { createTranslator, normalizeLocale } from '../i18n/index.mjs'

export function buildInviteContent(locale) {
  const normalizedLocale = normalizeLocale(locale) || 'zh'
  const t = createTranslator(normalizedLocale)

  return Object.freeze({
    locale: normalizedLocale,
    brand: t('common.brand.name'),
    languageLabel: t('common.language.label'),
    headline: t('invite.headline'),
    description: t('invite.description'),
    download: t('invite.download'),
    applePrefix: t('common.store.appleprefix'),
    appleName: t('common.store.applename'),
    googlePrefix: t('common.store.googleprefix'),
    googleName: t('common.store.googlename'),
    loadingAlt: t('invite.loadingalt'),
    screensAlt: t('invite.screensalt')
  })
}
